// Module
var code = "<label for=\"faq-[[faqValue]]\" class=\"radio\"> <input id=\"faq-[[faqValue]]\" name=\"[[name]]\" type=\"radio\" ng-model=\"ngModel\" value=\"[[faqValue]]\" ng-change=\"changeTopic()\" ng-required=\"isRequired\"/> [[faqFormLabel]] </label> ";
// Exports
export default code;